<template>
    <b-modal id="modalViewTransacaoAvulsa" title="Transação avulsa"
        hide-footer size="lg">
        <div class="container" v-if="isVindi">
            <div class="row">
                <div class="col">
                    <label>ID</label>
                    <h6>{{transacao.vindi.id}}</h6>
                </div>
                <div class="col">
                    <label>Produto</label>
                    <h6>{{transacao.vindi.bill_items[0].product.name}}</h6>
                </div>
                <div class="col">
                    <label>Valor (R$)</label>
                    <h6>{{transacao.vlTotal | money}}</h6>
                </div>
            </div>
            <hr>
            <div class="row">
                <div class="col">
                    <label>Status Pagamento</label>
                    <h6>{{traduzirStatusPagamento(transacao.vindi)}}</h6>
                </div>
                <div class="col">
                    <label>Data Vencimento</label>
                    <h6>{{formataData(getCharge(transacao.vindi.charges) ? (transacao.vindi.charges).due_at : '')}}</h6>
                </div>
            </div>
            <hr>
            <div class="row">
                <div class="col">
                    <label>Observação</label>
                    <h6>{{transacao.vindi.bill_items[0].description}}</h6>
                </div>
            </div>
            <hr v-if="isTaxaEmissao && transacao.metadata && transacao.metadata.tipo === 'cartaoFisico'">
            <div class="row" v-if="isTaxaEmissao">
                <div class="col-12">
                    <h6>Dados para emissao do cartao</h6>
                </div>
                <div class="col">
                    <table class="table striped">
                        <thead>
                            <th>#</th>
                            <th>Nome</th>
                        </thead>
                        <tbody>
                            <tr v-for="(card, i) in transacao.metadata.values" :key="i">
                                <td>
                                    {{++i}}
                                </td>
                                <td>
                                    {{card.name}}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

        </div>
        <div class="container" v-if="isPagarme">
          <div class="row">
            <div class="col">
              <label>ID</label>
              <h6>{{transacao.pagarme.id}}</h6>
            </div>
            <div class="col">
              <label>Produto</label>
              <h6>{{transacao.metadata.title}}</h6>
            </div>
            <div class="col">
              <label>Valor (R$)</label>
              <h6>{{transacao.vlTotal | money}}</h6>
            </div>
          </div>
          <hr>
          <div class="row">
            <div class="col">
              <label>Status Pagamento</label>
              <h6>{{traduzirStatusPagamento(transacao.pagarme)}}</h6>
            </div>
            <div class="col">
              <label>Data Vencimento</label>
              <h6>{{formataData(transacao.pagarme.date_created)}}</h6>
            </div>
          </div>
          <hr>
          <div class="row">
            <div class="col">
              <label>Observação</label>
              <h6>{{transacao.metadata.observacao}}</h6>
            </div>
          </div>
          <hr v-if="transacao.metadata && transacao.metadata.tipo === 'cartaoFisico'">
          <div class="row" v-if="transacao.metadata && transacao.metadata.tipo === 'cartaoFisico'">
            <div class="col-12">
              <h6>Dados para emissao do cartao</h6>
            </div>
            <div class="col">
              <table class="table striped">
                <thead>
                <th>#</th>
                <th>Nome</th>
                </thead>
                <tbody>
                <tr v-for="(card, i) in transacao.metadata.values" :key="i">
                  <td>
                    {{++i}}
                  </td>
                  <td>
                    {{card.name}}
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
    </b-modal>
</template>
<script>
import moment from 'moment';

export default {
    props: {
        pedido: {
            type: Object,
            required: true
        },
        transacao: {
            type: Object,
            required: true
        }
    },
    computed: {
        isTaxaEmissao() {
            return this.transacao && this.transacao.vindi.bill_items[0].product.code === 'taxaEmissaoCartao';
        },
        isPagarme() {
          return this.transacao && this.transacao.pagarme;
        },
        isVindi() {
          return this.transacao && this.transacao.vindi;
        }
    },
    methods: {
        getCharge(charges) {
            if (!charges) {
            return {}
            }
            if (charges.length == 1) {
            return charges[0];
            }

            return charges.find(charge => charge.status === 'pending' || charge.status === 'paid')
        },
        traduzirStatusPagamento(fatura) {
            let statusVindi = null;
            if (this.isVindi) {
              statusVindi = this.getCharge(fatura.charges) ? this.getCharge(fatura.charges).last_transaction.status : fatura.status || fatura.status;
            } else {
              statusVindi = fatura.status;
            }
            switch (statusVindi) {
                case 'processing':
                return 'Processando pagamento';
                case 'failure':
                return 'Falha ao processar pagamento';
                case 'rejected':
                return 'Pagamento rejeitado';
                case 'success':
                return 'Pagamento Efetuado';
                case 'paid':
                return 'Pagamento Efetuado';
                case 'waiting':
                if (this.isVencida(fatura)) {
                    return 'Vencida'
                }
                return 'Aguardando pagamento';
                case 'canceled':
                return 'Cancelado';
                default:
                return statusVindi;
            }
      },
      isVencida(fatura) {
        if (this.getCharge(fatura.charges)) {
            let dataVencimento = new Date(this.getCharge(fatura.charges).due_at);
            return moment().isSameOrAfter(dataVencimento);
        }
        return false
      },
      formataData(value) {
        if (!value) return '';
        return moment(value).format("DD/MM/YYYY");
      }
    }
}
</script>
